import Avatar from '@mui/material/Avatar';

import {formatProviderName} from '../../helpers/providers';

const ProviderAvatar = ({provider, size = 40, ...props}) => {
  return (
    <Avatar
      alt={formatProviderName(provider)}
      size={size}
      sx={props?.sx}
      src={provider?.imgSrc || provider?.public_profile_img_url || provider?.provider?.public_profile_img_url}
    />
  );
};

export default ProviderAvatar;